import styled from 'styled-components';

export const AppFooterContainer = styled.footer`
  @media (min-width: 960px) {
    background-color: ${props => props.theme.footerBg};
    height: 6vh;
    border-top: 1px solid #1c1d25;

    & .App-footer-ul-logo {
      display: flex;
      align-items: center;
      max-width: 300px;
      width: 10%;
      height: 100%;
    }

    & .App-footer-ul-logo > img {
      width: 100%;
      height: 80%;
      max-width: 150px;
    }

    & .App-footer-ul {
      display: flex;
      min-width: 1000px;
      width: 40%;
      margin: 0 0 0 15%;
      height: 100%;
    }
    
    & .App-footer-ul > li {
      flex: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 15px;
      cursor: pointer;
      position: relative;
    }

    & .App-footer-ul a {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${props => props.theme.footerBtnColor};
    }

    & .App-footer-ul > li > div.mainMenu:hover > a {
      color: ${props => props.theme.footerSelectBtnColor};
      text-decoration: none;
    }

    & .App-footer-ul > li > div.subMenu > ul > li:hover > a {
      color: #fff;
      text-decoration: none;
    }

    & .App-footer-ul > li > div.mainMenu {
      width: 100%;
      height: 98%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
    }

    & .App-footer-ul > li > div.subMenu {
      position: absolute;
      width: 100%;
      height: 100%;
      color: #60687d;
      display: none;
    }

    & .App-footer-ul > li > div.on {
      display: block;
    }

    & .App-footer-ul > li > div.subMenu > ul {
      padding: 0px;
      width: 100%;
      height: 100%;
    }

    & .App-footer-ul > li > div.subMenu > ul > li {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #101010;
      border-bottom: 1px solid #1e1e1e;
    }
  }

  & nav {
    height: 100%;
    display: flex;
  }

  & .App-footer-ul > li > div.mainMenu > a.activate {
    color: ${props => props.theme.footerSelectBtnColor};
  }

  & .App-footer-ul > li > div.subMenu > ul > li > a.activate {
    color: #fff;
  }

  & .App-footer-ul > li > div.mainMenu > a.activate,
  & .App-footer-ul > li > div.mainMenu > a:hover {
    box-shadow: inset 0px -23px 25px -17px #66bfef, inset 0px -1px 1px -1px #02c5ff;
  }

  @media (max-width: 960px) {
    & {
      background-color: ${props => props.theme.footerBg};
      border-top: 1px solid #1c1d25;
    }

    & .App-footer-ul {
      display: flex;
      height: 100%;
      flex-wrap: wrap;
      width: 100%;
      margin: 0px;
      padding: 0px;
    }
    
    & .App-footer-ul > li {
      flex: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 15px;
      cursor: pointer;
      min-width: 33vw;
      min-height: 50px;
      border: 1px solid #a7a7a724;
    }
  }
`
